/**
 * @generated SignedSource<<87256173845496fc34d1f294500884aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MembershipPlanDetailsCard_OrganizationFragment$data = {
  readonly id: string;
  readonly viewerMembershipPlan: {
    readonly id: string;
  };
  readonly " $fragmentType": "MembershipPlanDetailsCard_OrganizationFragment";
};
export type MembershipPlanDetailsCard_OrganizationFragment$key = {
  readonly " $data"?: MembershipPlanDetailsCard_OrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanDetailsCard_OrganizationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembershipPlanDetailsCard_OrganizationFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "viewerMembershipPlan",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "0cd19329524511b9d90b9ff9d68394f8";

export default node;
